import React, { useState, useRef } from 'react';
import { Crown, Check, CheckCircle2, ShieldCheck, LayoutGrid, Target, Megaphone, Zap, FileText, Star, Users, Layers, TrendingUp, CalendarDays, ShoppingBag, X, ArrowRight, Clock, Eye } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface PromotionTabProps {
  showToast: (msg: string) => void;
  setActiveAutoService: (service: string | null) => void;
}
export function PromotionTab({
  showToast,
  setActiveAutoService
}: PromotionTabProps) {
  const [showPinModal, setShowPinModal] = useState(false);
  const [pinStep, setPinStep] = useState<1 | 2 | 3 | 'success'>(1);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedDuration, setSelectedDuration] = useState<'1week' | '2weeks' | '1month'>('1week');
  const [showTariffModal, setShowTariffModal] = useState(false);
  const [selectedTariff, setSelectedTariff] = useState<'pro' | 'top' | null>(null);
  const [tariffStep, setTariffStep] = useState<'compare' | 'success'>('compare');
  const [activePins, setActivePins] = useState([{
    id: 1,
    category: 'Натальная карта',
    daysLeft: 5,
    totalDays: 7,
    views: 1247
  }, {
    id: 2,
    category: 'Совместимость',
    daysLeft: 12,
    totalDays: 14,
    views: 834
  }]);
  const [myOrders, setMyOrders] = useState([{
    id: 'ORD-A-001',
    type: 'banner',
    name: 'Баннер на главной',
    status: 'active',
    startDate: '01.03.2026',
    endDate: '07.03.2026',
    price: 5000,
    views: 12400
  }, {
    id: 'ORD-A-002',
    type: 'email',
    name: 'Рассылка по базе',
    status: 'completed',
    startDate: '15.02.2026',
    endDate: '15.02.2026',
    price: 3000,
    views: 10200
  }, {
    id: 'ORD-A-003',
    type: 'package',
    name: 'Пакет Натальная карта ×100',
    status: 'active',
    startDate: '01.03.2026',
    endDate: null,
    price: 6900,
    remaining: 47
  }]);
  // Banner Modal State
  const [showBannerModal, setShowBannerModal] = useState(false);
  const [bannerStep, setBannerStep] = useState<1 | 2 | 3 | 'success'>(1);
  const [selectedBannerSlot, setSelectedBannerSlot] = useState<string>('Главная TOP');
  const [selectedBannerDuration, setSelectedBannerDuration] = useState<'1week' | '2weeks' | '1month'>('1week');
  // Email Modal State
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailStep, setEmailStep] = useState<1 | 2 | 3 | 'success'>(1);
  const [selectedEmailAudience, setSelectedEmailAudience] = useState<string>('5k');
  // Package Modal State
  const [showPackageModal, setShowPackageModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<{
    name: string;
    qty: number;
    price: number;
    discount?: string;
  } | null>(null);
  const packagesRef = useRef<HTMLDivElement>(null);
  const scrollToPackages = () => {
    packagesRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <div className="space-y-6" data-id="element-12477">
      <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-6" data-id="element-12478">
        Продвижение профиля
      </h2>

      {/* Section 1: Current Plan Summary */}
      <Card padding="md" className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white border-none relative overflow-hidden" data-id="element-12479">
        <div className="absolute top-0 right-0 -mt-4 -mr-4 w-32 h-32 bg-white opacity-10 rounded-full blur-2xl" data-id="element-12480"></div>
        <div className="absolute bottom-0 left-1/2 w-40 h-40 bg-purple-400 opacity-20 rounded-full blur-3xl" data-id="element-12481"></div>

        <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-12482">
          <div data-id="element-12483">
            <div className="flex items-center gap-2 mb-2" data-id="element-12484">
              <span className="text-indigo-100 text-sm font-medium" data-id="element-12485">
                Текущий тариф
              </span>
              <Badge variant="success" className="bg-emerald-400/20 text-emerald-100 border-emerald-400/30" data-id="element-12486">
                Активен
              </Badge>
            </div>
            <h3 className="text-3xl font-bold flex items-center gap-2 mb-1" data-id="element-12487">
              Базовый <Crown className="w-6 h-6 text-amber-300" data-id="element-12488" />
            </h3>
            <p className="text-indigo-100 text-sm max-w-md" data-id="element-12489">
              Улучшите план до PRO или TOP, чтобы получать больше заказов и
              занять высокие позиции в каталоге.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 bg-white/10 p-4 rounded-xl backdrop-blur-sm border border-white/10" data-id="element-12490">
            <div data-id="element-12491">
              <div className="text-indigo-200 text-xs mb-1" data-id="element-12492">
                Позиция в каталоге
              </div>
              <div className="text-xl font-bold" data-id="element-12493">#47</div>
            </div>
            <div className="hidden sm:block w-px bg-white/20" data-id="element-12494"></div>
            <div data-id="element-12495">
              <div className="text-indigo-200 text-xs mb-1" data-id="element-12496">
                Просмотры за месяц
              </div>
              <div className="text-xl font-bold" data-id="element-12497">1,247</div>
            </div>
            <div className="hidden sm:block w-px bg-white/20" data-id="element-12498"></div>
            <div data-id="element-12499">
              <div className="text-indigo-200 text-xs mb-1" data-id="element-12500">Конверсия</div>
              <div className="text-xl font-bold" data-id="element-12501">8.3%</div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Мои рекламные заказы */}
      <div className="mt-10 mb-8" data-id="element-12502">
        <div className="flex items-center justify-between mb-4" data-id="element-12503">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-12504">
            Мои рекламные заказы
          </h3>
          <Button variant="ghost" size="sm" className="text-indigo-600" data-id="element-12505">
            Все заказы <ArrowRight className="w-4 h-4 ml-1" data-id="element-12506" />
          </Button>
        </div>

        <Card padding="none" className="overflow-hidden border-slate-200" data-id="element-12507">
          <div className="overflow-x-auto" data-id="element-12508">
            <table className="w-full text-left text-sm" data-id="element-12509">
              <thead className="bg-slate-50 border-b border-slate-200 text-slate-500" data-id="element-12510">
                <tr data-id="element-12511">
                  <th className="px-4 py-3 font-medium" data-id="element-12512">Услуга</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12513">Статус</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12514">Период</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12515">Стоимость</th>
                  <th className="px-4 py-3 font-medium text-right" data-id="element-12516">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-12517">
                {myOrders.map(order => <tr key={order.id} className="hover:bg-slate-50 transition-colors" data-id="element-12518">
                    <td className="px-4 py-3" data-id="element-12519">
                      <div className="font-bold text-slate-900" data-id="element-12520">
                        {order.name}
                      </div>
                      <div className="text-xs text-slate-500 font-mono mt-0.5" data-id="element-12521">
                        {order.id}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-12522">
                      <Badge variant={order.status === 'active' ? 'success' : order.status === 'completed' ? 'neutral' : 'warning'} size="sm" data-id="element-12523">
                        {order.status === 'active' ? 'Активен' : order.status === 'completed' ? 'Завершен' : 'В ожидании'}
                      </Badge>
                    </td>
                    <td className="px-4 py-3 text-slate-600" data-id="element-12524">
                      {order.endDate ? `${order.startDate} — ${order.endDate}` : `С ${order.startDate}`}
                    </td>
                    <td className="px-4 py-3 font-medium text-slate-900" data-id="element-12525">
                      {order.price.toLocaleString('ru-RU')} ₽
                    </td>
                    <td className="px-4 py-3 text-right" data-id="element-12526">
                      <Button variant="ghost" size="sm" className="text-indigo-600 hover:bg-indigo-50" data-id="element-12527">
                        Детали
                      </Button>
                    </td>
                  </tr>)}
                {myOrders.length === 0 && <tr data-id="element-12528">
                    <td colSpan={5} className="px-4 py-8 text-center text-slate-500" data-id="element-12529">
                      У вас пока нет рекламных заказов
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* Section 2: Pricing Plans */}
      <h3 className="text-lg font-bold text-slate-900 mt-8 mb-4" data-id="element-12530">
        Тарифные планы
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-12531">
        <Card padding="lg" className="flex flex-col relative border-slate-200" data-id="element-12532">
          <div className="mb-6" data-id="element-12533">
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-12534">Базовый</h3>
            <div className="flex items-baseline gap-1" data-id="element-12535">
              <span className="text-3xl font-bold text-slate-900" data-id="element-12536">
                Бесплатно
              </span>
            </div>
            <p className="text-sm text-slate-500 mt-2" data-id="element-12537">
              Базовые возможности для старта
            </p>
          </div>

          <ul className="space-y-3 mb-8 flex-1" data-id="element-12538">
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12539">
              <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-12540" />
              Базовый профиль в каталоге
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12541">
              <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-12542" />
              До 3 услуг
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12543">
              <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-12544" />
              Стандартная позиция в поиске
            </li>
          </ul>

          <div className="w-full py-2.5 px-4 bg-slate-50 border border-slate-200 rounded-xl text-center text-sm font-medium text-slate-600 flex items-center justify-center gap-2" data-id="element-12545">
            <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-12546" /> Ваш текущий
            план
          </div>
        </Card>

        <Card padding="lg" className="flex flex-col relative border-indigo-200 shadow-md ring-1 ring-indigo-100" data-id="element-12547">
          <div className="absolute top-0 right-0 bg-indigo-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg rounded-tr-xl uppercase tracking-wider" data-id="element-12548">
            Популярный
          </div>
          <div className="mb-6" data-id="element-12549">
            <h3 className="text-xl font-bold text-indigo-700 mb-2 flex items-center gap-2" data-id="element-12550">
              PRO <ShieldCheck className="w-5 h-5" data-id="element-12551" />
            </h3>
            <div className="flex items-baseline gap-1" data-id="element-12552">
              <span className="text-3xl font-bold text-slate-900" data-id="element-12553">3 000 ₽</span>
              <span className="text-slate-500" data-id="element-12554">/ мес</span>
            </div>
            <p className="text-sm text-slate-500 mt-2" data-id="element-12555">
              Для активных специалистов
            </p>
          </div>

          <ul className="space-y-3 mb-8 flex-1" data-id="element-12556">
            <li className="flex items-start gap-2 text-sm text-slate-600 font-medium" data-id="element-12557">
              <Check className="w-4 h-4 text-indigo-500 mt-0.5 flex-shrink-0" data-id="element-12558" />
              Бейдж PRO (верификация)
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12559">
              <Check className="w-4 h-4 text-indigo-500 mt-0.5 flex-shrink-0" data-id="element-12560" />
              Приоритет в поиске
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12561">
              <Check className="w-4 h-4 text-indigo-500 mt-0.5 flex-shrink-0" data-id="element-12562" />
              До 10 услуг
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12563">
              <Check className="w-4 h-4 text-indigo-500 mt-0.5 flex-shrink-0" data-id="element-12564" />
              Расширенная аналитика
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12565">
              <Check className="w-4 h-4 text-indigo-500 mt-0.5 flex-shrink-0" data-id="element-12566" />
              Поддержка в чате
            </li>
          </ul>

          <Button variant="primary" fullWidth onClick={() => {
          setSelectedTariff('pro');
          setTariffStep('compare');
          setShowTariffModal(true);
        }} data-id="element-12567">
            Улучшить до PRO
          </Button>
        </Card>

        <Card padding="lg" className="flex flex-col relative bg-gradient-to-b from-amber-50/50 to-white border-amber-200" data-id="element-12568">
          <div className="mb-6" data-id="element-12569">
            <h3 className="text-xl font-bold text-amber-700 mb-2 flex items-center gap-2" data-id="element-12570">
              TOP <Crown className="w-5 h-5" data-id="element-12571" />
            </h3>
            <div className="flex items-baseline gap-1" data-id="element-12572">
              <span className="text-3xl font-bold text-slate-900" data-id="element-12573">7 000 ₽</span>
              <span className="text-slate-500" data-id="element-12574">/ мес</span>
            </div>
            <p className="text-sm text-slate-500 mt-2" data-id="element-12575">
              Максимальный охват и продажи
            </p>
          </div>

          <ul className="space-y-3 mb-8 flex-1" data-id="element-12576">
            <li className="flex items-start gap-2 text-sm text-slate-900 font-bold" data-id="element-12577">
              <Check className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-12578" />
              Всё из плана PRO
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600 font-medium" data-id="element-12579">
              <Check className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-12580" />
              Бейдж TOP Астролог
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12581">
              <Check className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-12582" />
              Закрепление вверху каталога
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12583">
              <Check className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-12584" />
              Блок на главной странице
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12585">
              <Check className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-12586" />
              Неограниченно услуг
            </li>
            <li className="flex items-start gap-2 text-sm text-slate-600" data-id="element-12587">
              <Check className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-12588" />
              Персональный менеджер
            </li>
          </ul>

          <Button variant="outline" className="border-amber-300 text-amber-700 hover:bg-amber-50" fullWidth onClick={() => {
          setSelectedTariff('top');
          setTariffStep('compare');
          setShowTariffModal(true);
        }} data-id="element-12589">
            Улучшить до TOP
          </Button>
        </Card>
      </div>

      {/* Section: Активные закрепы */}
      <div className="mt-10 mb-8" data-id="element-12590">
        <div className="flex items-center justify-between mb-4" data-id="element-12591">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-12592">Активные закрепы</h3>
          <Button variant="outline" size="sm" onClick={() => {
          setShowPinModal(true);
          setPinStep(1);
          setSelectedCategories([]);
        }} data-id="element-12593">
            + Новый закреп
          </Button>
        </div>

        {activePins.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-12594">
            {activePins.map(pin => <Card key={pin.id} padding="md" className="border-amber-200 bg-gradient-to-br from-amber-50/50 to-white relative overflow-hidden" data-id="element-12595">
                <div className="absolute top-0 right-0 bg-amber-100 text-amber-700 text-[10px] font-bold px-2 py-1 rounded-bl-lg" data-id="element-12596">
                  Активен
                </div>
                <div className="flex items-center gap-2 mb-3" data-id="element-12597">
                  <Target className="w-5 h-5 text-amber-500" data-id="element-12598" />
                  <h4 className="font-bold text-slate-900" data-id="element-12599">{pin.category}</h4>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-12600">
                  <div data-id="element-12601">
                    <div className="text-xs text-slate-500 mb-1 flex items-center gap-1" data-id="element-12602">
                      <Clock className="w-3 h-3" data-id="element-12603" /> Осталось дней
                    </div>
                    <div className="font-bold text-slate-900" data-id="element-12604">
                      {pin.daysLeft} из {pin.totalDays}
                    </div>
                  </div>
                  <div data-id="element-12605">
                    <div className="text-xs text-slate-500 mb-1 flex items-center gap-1" data-id="element-12606">
                      <Eye className="w-3 h-3" data-id="element-12607" /> Просмотры
                    </div>
                    <div className="font-bold text-slate-900" data-id="element-12608">
                      {pin.views.toLocaleString('ru-RU')}
                    </div>
                  </div>
                </div>

                <div className="w-full bg-slate-100 rounded-full h-1.5 mb-4" data-id="element-12609">
                  <div className="bg-amber-400 h-1.5 rounded-full" style={{
              width: `${pin.daysLeft / pin.totalDays * 100}%`
            }} data-id="element-12610" />
                </div>

                <div className="flex gap-2" data-id="element-12611">
                  <Button variant="outline" size="sm" className="flex-1 text-xs" onClick={() => showToast('Продление закрепа')} data-id="element-12612">
                    Продлить
                  </Button>
                  <Button variant="ghost" size="sm" className="text-rose-500 hover:bg-rose-50 px-2" onClick={() => {
              setActivePins(prev => prev.filter(p => p.id !== pin.id));
              showToast('Закреп отменен');
            }} data-id="element-12613">
                    Отменить
                  </Button>
                </div>
              </Card>)}
          </div> : <Card padding="md" className="border-dashed border-slate-200 bg-slate-50 flex flex-col items-center justify-center text-center py-8" data-id="element-12614">
            <Target className="w-8 h-8 text-slate-300 mb-2" data-id="element-12615" />
            <div className="text-sm font-medium text-slate-600 mb-1" data-id="element-12616">
              У вас нет активных закрепов
            </div>
            <div className="text-xs text-slate-500 mb-4" data-id="element-12617">
              Закрепите профиль в топе каталога, чтобы получать больше клиентов
            </div>
            <Button variant="primary" size="sm" onClick={() => {
          setShowPinModal(true);
          setPinStep(1);
          setSelectedCategories([]);
        }} data-id="element-12618">
              Оформить закрепление
            </Button>
          </Card>}
      </div>

      {/* Section 3: Дополнительные услуги продвижения */}
      <h3 className="text-lg font-bold text-slate-900 mt-10 mb-4" data-id="element-12619">
        Дополнительные услуги продвижения
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-12620">
        <Card padding="md" className="flex flex-col h-full hover:border-indigo-300 transition-colors" data-id="element-12621">
          <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center mb-4" data-id="element-12622">
            <LayoutGrid className="w-6 h-6 text-indigo-600" data-id="element-12623" />
          </div>
          <h4 className="font-bold text-slate-900 mb-1" data-id="element-12624">Баннер на главной</h4>
          <div className="text-indigo-600 font-bold mb-3" data-id="element-12625">
            5 000 ₽{' '}
            <span className="text-xs text-slate-500 font-normal" data-id="element-12626">/ неделя</span>
          </div>
          <p className="text-sm text-slate-600 mb-6 flex-1" data-id="element-12627">
            Ваш профиль будет отображаться в специальном блоке рекомендаций на
            главной странице платформы.
          </p>
          <Button variant="outline" fullWidth onClick={() => {
          setShowBannerModal(true);
          setBannerStep(1);
          setSelectedBannerSlot('Главная TOP');
          setSelectedBannerDuration('1week');
        }} data-id="element-12628">
            Заказать
          </Button>
        </Card>

        <Card padding="md" className="flex flex-col h-full hover:border-indigo-300 transition-colors" data-id="element-12629">
          <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mb-4" data-id="element-12630">
            <Target className="w-6 h-6 text-rose-600" data-id="element-12631" />
          </div>
          <h4 className="font-bold text-slate-900 mb-1" data-id="element-12632">
            Закрепление в каталоге
          </h4>
          <div className="text-rose-600 font-bold mb-3" data-id="element-12633">
            2 000 ₽{' '}
            <span className="text-xs text-slate-500 font-normal" data-id="element-12634">/ неделя</span>
          </div>
          <p className="text-sm text-slate-600 mb-6 flex-1" data-id="element-12635">
            Ваш профиль будет закреплён в топ-5 каталога астрологов, что
            увеличит количество просмотров.
          </p>
          <Button variant="outline" fullWidth onClick={() => {
          setShowPinModal(true);
          setPinStep(1);
          setSelectedCategories([]);
        }} data-id="element-12636">
            Заказать
          </Button>
        </Card>

        <Card padding="md" className="flex flex-col h-full hover:border-indigo-300 transition-colors" data-id="element-12637">
          <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center mb-4" data-id="element-12638">
            <Megaphone className="w-6 h-6 text-emerald-600" data-id="element-12639" />
          </div>
          <h4 className="font-bold text-slate-900 mb-1" data-id="element-12640">Рассылка по базе</h4>
          <div className="text-emerald-600 font-bold mb-3" data-id="element-12641">
            3 000 ₽{' '}
            <span className="text-xs text-slate-500 font-normal" data-id="element-12642">/ разово</span>
          </div>
          <p className="text-sm text-slate-600 mb-6 flex-1" data-id="element-12643">
            Email-рассылка с информацией о вашем профиле и услугах по базе 10
            000+ активных пользователей.
          </p>
          <Button variant="outline" fullWidth onClick={() => {
          setShowEmailModal(true);
          setEmailStep(1);
          setSelectedEmailAudience('5k');
        }} data-id="element-12644">
            Заказать
          </Button>
        </Card>
      </div>

      {/* Section 4: Автоматические услуги платформы */}
      <h3 className="text-lg font-bold text-slate-900 mt-10 mb-2" data-id="element-12645">
        Автоматические услуги платформы
      </h3>
      <p className="text-sm text-slate-500 mb-4" data-id="element-12646">
        Платформа автоматически генерирует разборы, натальные карты и календари
        для ваших клиентов. Покупайте поштучно или выгодными пакетами.
      </p>

      {/* Current balance */}
      <Card padding="md" className="border-sky-100 mb-6" data-id="element-12647">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5" data-id="element-12648">
          <div className="flex items-center gap-3" data-id="element-12649">
            <div className="w-10 h-10 rounded-xl bg-sky-100 flex items-center justify-center" data-id="element-12650">
              <Zap className="w-5 h-5 text-sky-600" data-id="element-12651" />
            </div>
            <div data-id="element-12652">
              <div className="text-sm font-bold text-slate-900" data-id="element-12653">
                Баланс авто-услуг
              </div>
              <div className="text-xs text-slate-500" data-id="element-12654">
                Использование за текущий месяц (Октябрь 2024)
              </div>
            </div>
          </div>
          <Badge variant="pro" className="bg-sky-100 text-sky-700 border-sky-200 flex-shrink-0" data-id="element-12655">
            Пакет «PRO-1000» активен
          </Badge>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-12656">
          {[{
          name: 'Натальная карта',
          icon: FileText,
          color: 'indigo',
          total: 1000,
          used: 153,
          active: true
        }, {
          name: 'Соляр',
          icon: Star,
          color: 'amber',
          total: 500,
          used: 47,
          active: true
        }, {
          name: 'Синастрия',
          icon: Users,
          color: 'rose',
          total: 200,
          used: 89,
          active: true
        }, {
          name: 'Комбо (Натал+Соляр)',
          icon: Layers,
          color: 'emerald',
          total: 0,
          used: 0,
          active: false
        }, {
          name: 'Транзиты',
          icon: TrendingUp,
          color: 'sky',
          total: 0,
          used: 0,
          active: false
        }, {
          name: 'Астро-календарь',
          icon: CalendarDays,
          color: 'purple',
          total: 0,
          used: 0,
          active: false
        }].map(service => {
          const remaining = service.total - service.used;
          const percent = service.total > 0 ? service.used / service.total * 100 : 0;
          const isLow = service.total > 0 && remaining < service.total * 0.15;
          return <div key={service.name} className={`rounded-xl border p-3 ${service.active ? 'bg-white border-slate-200' : 'bg-slate-50 border-slate-100'}`} data-id="element-12657">
                <div className="flex items-center justify-between mb-2" data-id="element-12658">
                  <div className="flex items-center gap-2" data-id="element-12659">
                    <service.icon className={`w-4 h-4 ${service.active ? `text-${service.color}-500` : 'text-slate-400'}`} data-id="element-12660" />
                    <span className={`text-xs font-semibold ${service.active ? 'text-slate-900' : 'text-slate-400'}`} data-id="element-12661">
                      {service.name}
                    </span>
                  </div>
                  {service.active ? <div className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-12662" /> : <div className="w-2 h-2 rounded-full bg-slate-300" data-id="element-12663" />}
                </div>

                {service.active ? <>
                    <div className="flex items-baseline gap-1 mb-1.5" data-id="element-12664">
                      <span className="text-lg font-bold text-slate-900" data-id="element-12665">
                        {remaining}
                      </span>
                      <span className="text-[10px] text-slate-400" data-id="element-12666">
                        / {service.total} осталось
                      </span>
                    </div>
                    <div className="w-full bg-slate-100 rounded-full h-1.5 mb-2" data-id="element-12667">
                      <div className={`h-1.5 rounded-full transition-all ${isLow ? 'bg-rose-500' : percent > 50 ? 'bg-amber-500' : 'bg-emerald-500'}`} style={{
                  width: `${percent}%`
                }} data-id="element-12668" />
                    </div>
                    <div className="flex items-center justify-between" data-id="element-12669">
                      <span className="text-[10px] text-slate-500" data-id="element-12670">
                        Использовано:{' '}
                        <span className="font-semibold text-slate-700" data-id="element-12671">
                          {service.used}
                        </span>
                      </span>
                      {isLow && <span className="text-[10px] text-rose-500 font-medium" data-id="element-12672">
                          Заканчивается!
                        </span>}
                    </div>
                    <button onClick={() => showToast(`Докупка ${service.name} — переход к пакетам`)} className="w-full mt-2 text-[11px] font-medium text-primary hover:text-indigo-700 bg-indigo-50 hover:bg-indigo-100 rounded-lg py-1.5 transition-colors text-center" data-id="element-12673">
                      + Докупить
                    </button>
                  </> : <>
                    <div className="text-[11px] text-slate-400 mb-2" data-id="element-12674">
                      Не подключено
                    </div>
                    <button onClick={() => showToast(`Подключение ${service.name} — выберите пакет ниже`)} className="w-full text-[11px] font-medium text-slate-600 hover:text-slate-900 bg-white border border-slate-200 hover:border-slate-300 rounded-lg py-1.5 transition-colors text-center" data-id="element-12675">
                      Подключить
                    </button>
                  </>}
              </div>;
        })}
        </div>

        <div className="mt-4 pt-3 border-t border-slate-100 flex flex-col sm:flex-row sm:items-center justify-between gap-2" data-id="element-12676">
          <div className="text-xs text-slate-500" data-id="element-12677">
            Баланс обновляется 1-го числа каждого месяца. Неиспользованные
            единицы{' '}
            <span className="font-medium text-slate-700" data-id="element-12678">не сгорают</span>.
          </div>
          <Button variant="primary" size="sm" icon={<ShoppingBag className="w-3.5 h-3.5" data-id="element-12680" />} className="text-xs flex-shrink-0" onClick={() => {
          scrollToPackages();
          showToast('Переход к выбору пакетов');
        }} data-id="element-12679">
            Купить пакет
          </Button>
        </div>
      </Card>

      {/* Auto-service packages */}
      <div className="space-y-4" ref={packagesRef} data-id="element-12681">
        {/* Авто-разбор натальной карты */}
        <Card padding="md" data-id="element-12682">
          <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-12683">
            <div className="flex items-start gap-3 flex-1" data-id="element-12684">
              <div className="w-10 h-10 rounded-xl bg-indigo-100 flex items-center justify-center flex-shrink-0" data-id="element-12685">
                <FileText className="w-5 h-5 text-indigo-600" data-id="element-12686" />
              </div>
              <div data-id="element-12687">
                <h4 className="font-bold text-slate-900 mb-1" data-id="element-12688">
                  Авто-разбор натальной карты
                </h4>
                <p className="text-xs text-slate-500 mb-2" data-id="element-12689">
                  Полный разбор натальной карты клиента: аспекты, дома, планеты,
                  рекомендации. Готовый PDF-отчёт (30-40 стр).
                </p>
                <div className="flex items-center gap-1.5" data-id="element-12690">
                  <Badge variant="success" size="sm" data-id="element-12691">
                    Подключено
                  </Badge>
                  <span className="text-[10px] text-slate-400" data-id="element-12692">
                    Осталось 847 шт
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 md:flex-col md:items-end flex-shrink-0" data-id="element-12693">
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-разбор натальной карты',
                qty: 1,
                price: 99
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors whitespace-nowrap" data-id="element-12694">
                1 шт — <span className="font-bold" data-id="element-12695">99 ₽</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-разбор натальной карты',
                qty: 100,
                price: 6900,
                discount: '-30%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12696">
                100 шт — <span className="font-bold" data-id="element-12697">6 900 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12698">-30%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-разбор натальной карты',
                qty: 500,
                price: 29500,
                discount: '-40%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12699">
                500 шт — <span className="font-bold" data-id="element-12700">29 500 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12701">-40%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-разбор натальной карты',
                qty: 1000,
                price: 49000,
                discount: '-50%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-colors whitespace-nowrap" data-id="element-12702">
                1 000 шт — <span className="font-bold" data-id="element-12703">49 000 ₽</span>{' '}
                <span className="text-[10px] text-amber-500 ml-0.5" data-id="element-12704">-50%</span>
              </button>
            </div>
          </div>
        </Card>

        {/* Авто-соляр */}
        <Card padding="md" data-id="element-12705">
          <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-12706">
            <div className="flex items-start gap-3 flex-1" data-id="element-12707">
              <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0" data-id="element-12708">
                <Star className="w-5 h-5 text-amber-600" data-id="element-12709" />
              </div>
              <div data-id="element-12710">
                <h4 className="font-bold text-slate-900 mb-1" data-id="element-12711">
                  Авто-соляр (прогноз на год)
                </h4>
                <p className="text-xs text-slate-500 mb-2" data-id="element-12712">
                  Автоматический расчёт и интерпретация солярной карты. Полный
                  прогноз на год с рекомендациями по месяцам.
                </p>
                <div className="flex items-center gap-1.5" data-id="element-12713">
                  <Badge variant="neutral" size="sm" className="bg-slate-100 text-slate-500" data-id="element-12714">
                    Не подключено
                  </Badge>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 md:flex-col md:items-end flex-shrink-0" data-id="element-12715">
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-соляр',
                qty: 1,
                price: 149
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors whitespace-nowrap" data-id="element-12716">
                1 шт — <span className="font-bold" data-id="element-12717">149 ₽</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-соляр',
                qty: 100,
                price: 10400,
                discount: '-30%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12718">
                100 шт — <span className="font-bold" data-id="element-12719">10 400 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12720">-30%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-соляр',
                qty: 500,
                price: 44500,
                discount: '-40%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12721">
                500 шт — <span className="font-bold" data-id="element-12722">44 500 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12723">-40%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-соляр',
                qty: 1000,
                price: 74500,
                discount: '-50%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-colors whitespace-nowrap" data-id="element-12724">
                1 000 шт — <span className="font-bold" data-id="element-12725">74 500 ₽</span>{' '}
                <span className="text-[10px] text-amber-500 ml-0.5" data-id="element-12726">-50%</span>
              </button>
            </div>
          </div>
        </Card>

        {/* Авто-синастрия */}
        <Card padding="md" data-id="element-12727">
          <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-12728">
            <div className="flex items-start gap-3 flex-1" data-id="element-12729">
              <div className="w-10 h-10 rounded-xl bg-rose-100 flex items-center justify-center flex-shrink-0" data-id="element-12730">
                <Users className="w-5 h-5 text-rose-600" data-id="element-12731" />
              </div>
              <div data-id="element-12732">
                <h4 className="font-bold text-slate-900 mb-1" data-id="element-12733">
                  Авто-синастрия (совместимость)
                </h4>
                <p className="text-xs text-slate-500 mb-2" data-id="element-12734">
                  Автоматический анализ совместимости двух карт. Подробный отчёт
                  по аспектам взаимодействия пары.
                </p>
                <div className="flex items-center gap-1.5" data-id="element-12735">
                  <Badge variant="neutral" size="sm" className="bg-slate-100 text-slate-500" data-id="element-12736">
                    Не подключено
                  </Badge>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 md:flex-col md:items-end flex-shrink-0" data-id="element-12737">
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-синастрия',
                qty: 1,
                price: 129
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors whitespace-nowrap" data-id="element-12738">
                1 шт — <span className="font-bold" data-id="element-12739">129 ₽</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-синастрия',
                qty: 100,
                price: 9000,
                discount: '-30%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12740">
                100 шт — <span className="font-bold" data-id="element-12741">9 000 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12742">-30%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-синастрия',
                qty: 500,
                price: 38700,
                discount: '-40%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12743">
                500 шт — <span className="font-bold" data-id="element-12744">38 700 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12745">-40%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-синастрия',
                qty: 1000,
                price: 64500,
                discount: '-50%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-colors whitespace-nowrap" data-id="element-12746">
                1 000 шт — <span className="font-bold" data-id="element-12747">64 500 ₽</span>{' '}
                <span className="text-[10px] text-amber-500 ml-0.5" data-id="element-12748">-50%</span>
              </button>
            </div>
          </div>
        </Card>

        {/* Авто-комбо (Натал + Соляр) */}
        <Card padding="md" data-id="element-12749">
          <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-12750">
            <div className="flex items-start gap-3 flex-1" data-id="element-12751">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0" data-id="element-12752">
                <Layers className="w-5 h-5 text-emerald-600" data-id="element-12753" />
              </div>
              <div data-id="element-12754">
                <h4 className="font-bold text-slate-900 mb-1" data-id="element-12755">
                  Авто-комбо (Натал + Соляр)
                </h4>
                <p className="text-xs text-slate-500 mb-2" data-id="element-12756">
                  Полная картина: глубокий анализ натальной карты + прогноз на
                  год. Два отчёта в одном по выгодной цене.
                </p>
                <div className="flex items-center gap-1.5" data-id="element-12757">
                  <Badge variant="neutral" size="sm" className="bg-slate-100 text-slate-500" data-id="element-12758">
                    Не подключено
                  </Badge>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 md:flex-col md:items-end flex-shrink-0" data-id="element-12759">
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-комбо',
                qty: 1,
                price: 199
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors whitespace-nowrap" data-id="element-12760">
                1 шт — <span className="font-bold" data-id="element-12761">199 ₽</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-комбо',
                qty: 100,
                price: 13900,
                discount: '-30%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12762">
                100 шт — <span className="font-bold" data-id="element-12763">13 900 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12764">-30%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-комбо',
                qty: 500,
                price: 59700,
                discount: '-40%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12765">
                500 шт — <span className="font-bold" data-id="element-12766">59 700 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12767">-40%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-комбо',
                qty: 1000,
                price: 99500,
                discount: '-50%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-colors whitespace-nowrap" data-id="element-12768">
                1 000 шт — <span className="font-bold" data-id="element-12769">99 500 ₽</span>{' '}
                <span className="text-[10px] text-amber-500 ml-0.5" data-id="element-12770">-50%</span>
              </button>
            </div>
          </div>
        </Card>

        {/* Авто-прогноз (Транзиты) */}
        <Card padding="md" data-id="element-12771">
          <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-12772">
            <div className="flex items-start gap-3 flex-1" data-id="element-12773">
              <div className="w-10 h-10 rounded-xl bg-sky-100 flex items-center justify-center flex-shrink-0" data-id="element-12774">
                <TrendingUp className="w-5 h-5 text-sky-600" data-id="element-12775" />
              </div>
              <div data-id="element-12776">
                <h4 className="font-bold text-slate-900 mb-1" data-id="element-12777">
                  Авто-прогноз (Транзиты)
                </h4>
                <p className="text-xs text-slate-500 mb-2" data-id="element-12778">
                  Анализ текущих транзитов и ключевых периодов. Благоприятные
                  дни, зоны риска и рекомендации на каждый месяц.
                </p>
                <div className="flex items-center gap-1.5" data-id="element-12779">
                  <Badge variant="neutral" size="sm" className="bg-slate-100 text-slate-500" data-id="element-12780">
                    Не подключено
                  </Badge>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 md:flex-col md:items-end flex-shrink-0" data-id="element-12781">
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-прогноз',
                qty: 1,
                price: 119
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors whitespace-nowrap" data-id="element-12782">
                1 шт — <span className="font-bold" data-id="element-12783">119 ₽</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-прогноз',
                qty: 100,
                price: 8300,
                discount: '-30%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12784">
                100 шт — <span className="font-bold" data-id="element-12785">8 300 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12786">-30%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-прогноз',
                qty: 500,
                price: 35700,
                discount: '-40%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12787">
                500 шт — <span className="font-bold" data-id="element-12788">35 700 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12789">-40%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-прогноз',
                qty: 1000,
                price: 59500,
                discount: '-50%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-colors whitespace-nowrap" data-id="element-12790">
                1 000 шт — <span className="font-bold" data-id="element-12791">59 500 ₽</span>{' '}
                <span className="text-[10px] text-amber-500 ml-0.5" data-id="element-12792">-50%</span>
              </button>
            </div>
          </div>
        </Card>

        {/* Авто-календарь */}
        <Card padding="md" data-id="element-12793">
          <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-12794">
            <div className="flex items-start gap-3 flex-1" data-id="element-12795">
              <div className="w-10 h-10 rounded-xl bg-purple-100 flex items-center justify-center flex-shrink-0" data-id="element-12796">
                <CalendarDays className="w-5 h-5 text-purple-600" data-id="element-12797" />
              </div>
              <div data-id="element-12798">
                <h4 className="font-bold text-slate-900 mb-1" data-id="element-12799">
                  Авто-календарь (ежемесячный)
                </h4>
                <p className="text-xs text-slate-500 mb-2" data-id="element-12800">
                  Автоматическая генерация астро-календаря: транзиты, лунные
                  фазы, ретрограды, рекомендации на каждый день.
                </p>
                <div className="flex items-center gap-1.5" data-id="element-12801">
                  <Badge variant="neutral" size="sm" className="bg-slate-100 text-slate-500" data-id="element-12802">
                    Не подключено
                  </Badge>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 md:flex-col md:items-end flex-shrink-0" data-id="element-12803">
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-календарь',
                qty: 1,
                price: 199
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors whitespace-nowrap" data-id="element-12804">
                1 шт — <span className="font-bold" data-id="element-12805">199 ₽</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-календарь',
                qty: 50,
                price: 6950,
                discount: '-30%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12806">
                50 шт — <span className="font-bold" data-id="element-12807">6 950 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12808">-30%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-календарь',
                qty: 200,
                price: 23800,
                discount: '-40%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors whitespace-nowrap" data-id="element-12809">
                200 шт — <span className="font-bold" data-id="element-12810">23 800 ₽</span>{' '}
                <span className="text-[10px] text-indigo-400 ml-0.5" data-id="element-12811">-40%</span>
              </button>
              <button onClick={() => {
              setSelectedPackage({
                name: 'Авто-календарь',
                qty: 500,
                price: 49750,
                discount: '-50%'
              });
              setShowPackageModal(true);
            }} className="text-xs font-medium px-3 py-1.5 rounded-lg border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-colors whitespace-nowrap" data-id="element-12812">
                500 шт — <span className="font-bold" data-id="element-12813">49 750 ₽</span>{' '}
                <span className="text-[10px] text-amber-500 ml-0.5" data-id="element-12814">-50%</span>
              </button>
            </div>
          </div>
        </Card>
      </div>

      {/* Pin Purchase Modal */}
      {showPinModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm" data-id="element-12815">
          <Card className="w-full max-w-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]" padding="none" data-id="element-12816">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-white shrink-0" data-id="element-12817">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-12818">
                {pinStep === 1 && 'Выберите рубрики для закрепления'}
                {pinStep === 2 && 'Выберите срок закрепления'}
                {pinStep === 3 && 'Подтверждение заказа'}
                {pinStep === 'success' && 'Успешно'}
              </h3>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-12820" />} onClick={() => setShowPinModal(false)} data-id="element-12819" />
            </div>

            <div className="p-6 overflow-y-auto bg-slate-50 flex-1" data-id="element-12821">
              {pinStep === 1 && <div className="space-y-4" data-id="element-12822">
                  <p className="text-sm text-slate-600 mb-4" data-id="element-12823">
                    Ваш профиль будет отображаться на первых позициях в
                    выбранных рубриках.
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-12824">
                    {['Натальная карта', 'Соляр', 'Совместимость', 'Детская', 'Бизнес', 'Хорарная', 'Элективная', 'Медицинская', 'Кармическая', 'Финансовая', 'Астропсихология', 'Другое'].map(cat => <label key={cat} className={`flex items-center gap-3 p-3 rounded-xl border cursor-pointer transition-colors ${selectedCategories.includes(cat) ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-12825">
                        <input type="checkbox" className="w-4 h-4 text-indigo-600 rounded border-slate-300 focus:ring-indigo-500" checked={selectedCategories.includes(cat)} onChange={e => {
                  if (e.target.checked) {
                    setSelectedCategories([...selectedCategories, cat]);
                  } else {
                    setSelectedCategories(selectedCategories.filter(c => c !== cat));
                  }
                }} data-id="element-12826" />
                        <span className="text-sm font-medium text-slate-700" data-id="element-12827">
                          {cat}
                        </span>
                      </label>)}
                  </div>
                </div>}

              {pinStep === 2 && <div className="space-y-4" data-id="element-12828">
                  <div className="grid grid-cols-1 gap-3" data-id="element-12829">
                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedDuration === '1week' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-12830">
                      <div className="flex items-center gap-3" data-id="element-12831">
                        <input type="radio" name="duration" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedDuration === '1week'} onChange={() => setSelectedDuration('1week')} data-id="element-12832" />
                        <span className="font-bold text-slate-900" data-id="element-12833">
                          1 неделя
                        </span>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-12834">
                        2 000 ₽ / рубрика
                      </div>
                    </label>

                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedDuration === '2weeks' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-12835">
                      <div className="flex items-center gap-3" data-id="element-12836">
                        <input type="radio" name="duration" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedDuration === '2weeks'} onChange={() => setSelectedDuration('2weeks')} data-id="element-12837" />
                        <div className="flex items-center gap-2" data-id="element-12838">
                          <span className="font-bold text-slate-900" data-id="element-12839">
                            2 недели
                          </span>
                          <Badge variant="success" size="sm" className="text-[10px]" data-id="element-12840">
                            -12%
                          </Badge>
                        </div>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-12841">
                        3 500 ₽ / рубрика
                      </div>
                    </label>

                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedDuration === '1month' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-12842">
                      <div className="flex items-center gap-3" data-id="element-12843">
                        <input type="radio" name="duration" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedDuration === '1month'} onChange={() => setSelectedDuration('1month')} data-id="element-12844" />
                        <div className="flex items-center gap-2" data-id="element-12845">
                          <span className="font-bold text-slate-900" data-id="element-12846">
                            1 месяц
                          </span>
                          <Badge variant="success" size="sm" className="text-[10px]" data-id="element-12847">
                            -25%
                          </Badge>
                        </div>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-12848">
                        6 000 ₽ / рубрика
                      </div>
                    </label>
                  </div>

                  <div className="bg-white p-4 rounded-xl border border-slate-200 mt-4 flex justify-between items-center" data-id="element-12849">
                    <span className="text-sm text-slate-600" data-id="element-12850">
                      {selectedDuration === '1week' ? '2 000' : selectedDuration === '2weeks' ? '3 500' : '6 000'}{' '}
                      ₽ × {selectedCategories.length} рубрик
                    </span>
                    <span className="text-lg font-bold text-slate-900" data-id="element-12851">
                      {(selectedDuration === '1week' ? 2000 : selectedDuration === '2weeks' ? 3500 : 6000) * selectedCategories.length}{' '}
                      ₽
                    </span>
                  </div>
                </div>}

              {pinStep === 3 && <div className="space-y-6" data-id="element-12852">
                  <Card padding="md" className="border-slate-200 bg-white" data-id="element-12853">
                    <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-12854">
                      Детали заказа
                    </h4>

                    <div className="space-y-3 text-sm" data-id="element-12855">
                      <div className="flex justify-between pb-3 border-b border-slate-100" data-id="element-12856">
                        <span className="text-slate-500" data-id="element-12857">
                          Выбранные рубрики
                        </span>
                        <div className="flex flex-wrap gap-1 justify-end max-w-[60%]" data-id="element-12858">
                          {selectedCategories.map(cat => <Badge key={cat} variant="neutral" size="sm" className="text-[10px]" data-id="element-12859">
                              {cat}
                            </Badge>)}
                        </div>
                      </div>
                      <div className="flex justify-between pb-3 border-b border-slate-100" data-id="element-12860">
                        <span className="text-slate-500" data-id="element-12861">Срок размещения</span>
                        <span className="font-medium text-slate-900" data-id="element-12862">
                          {selectedDuration === '1week' ? '1 неделя' : selectedDuration === '2weeks' ? '2 недели' : '1 месяц'}
                        </span>
                      </div>
                      <div className="flex justify-between items-center pt-2" data-id="element-12863">
                        <span className="text-base font-bold text-slate-900" data-id="element-12864">
                          Итого к оплате
                        </span>
                        <span className="text-xl font-bold text-indigo-600" data-id="element-12865">
                          {(selectedDuration === '1week' ? 2000 : selectedDuration === '2weeks' ? 3500 : 6000) * selectedCategories.length}{' '}
                          ₽
                        </span>
                      </div>
                    </div>
                  </Card>

                  <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex gap-3" data-id="element-12866">
                    <Target className="w-5 h-5 text-amber-600 shrink-0" data-id="element-12867" />
                    <div className="text-sm text-amber-800" data-id="element-12868">
                      После оплаты ваш профиль будет закреплен в выбранных
                      рубриках в течение 15 минут.
                    </div>
                  </div>
                </div>}

              {pinStep === 'success' && <div className="flex flex-col items-center justify-center py-8 text-center" data-id="element-12869">
                  <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4" data-id="element-12870">
                    <CheckCircle2 className="w-8 h-8 text-emerald-600" data-id="element-12871" />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-12872">
                    Закрепление оформлено!
                  </h3>
                  <p className="text-slate-600 max-w-sm mb-6" data-id="element-12873">
                    Ваш профиль будет закреплён в выбранных рубриках в течение
                    15 минут. Вы можете управлять закрепами на вкладке
                    "Продвижение".
                  </p>
                </div>}
            </div>

            <div className="p-4 border-t border-slate-200 bg-white flex justify-between shrink-0" data-id="element-12874">
              {pinStep === 1 && <>
                  <Button variant="outline" onClick={() => setShowPinModal(false)} data-id="element-12875">
                    Отмена
                  </Button>
                  <Button variant="primary" disabled={selectedCategories.length === 0} onClick={() => setPinStep(2)} data-id="element-12876">
                    Далее <ArrowRight className="w-4 h-4 ml-1" data-id="element-12877" />
                  </Button>
                </>}
              {pinStep === 2 && <>
                  <Button variant="outline" onClick={() => setPinStep(1)} data-id="element-12878">
                    Назад
                  </Button>
                  <Button variant="primary" onClick={() => setPinStep(3)} data-id="element-12879">
                    Далее <ArrowRight className="w-4 h-4 ml-1" data-id="element-12880" />
                  </Button>
                </>}
              {pinStep === 3 && <>
                  <Button variant="outline" onClick={() => setPinStep(2)} data-id="element-12881">
                    Назад
                  </Button>
                  <Button variant="primary" onClick={() => {
              // Add to active pins
              const newPins = selectedCategories.map((cat, i) => ({
                id: Date.now() + i,
                category: cat,
                daysLeft: selectedDuration === '1week' ? 7 : selectedDuration === '2weeks' ? 14 : 30,
                totalDays: selectedDuration === '1week' ? 7 : selectedDuration === '2weeks' ? 14 : 30,
                views: 0
              }));
              setActivePins(prev => [...newPins, ...prev]);
              setPinStep('success');
            }} data-id="element-12882">
                    Оплатить{' '}
                    {(selectedDuration === '1week' ? 2000 : selectedDuration === '2weeks' ? 3500 : 6000) * selectedCategories.length}{' '}
                    ₽
                  </Button>
                </>}
              {pinStep === 'success' && <Button variant="primary" fullWidth onClick={() => setShowPinModal(false)} data-id="element-12883">
                  Готово
                </Button>}
            </div>
          </Card>
        </div>}

      {/* Tariff Upgrade Modal */}
      {showTariffModal && selectedTariff && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm" data-id="element-12884">
          <Card className="w-full max-w-3xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]" padding="none" data-id="element-12885">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-white shrink-0" data-id="element-12886">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-12887">
                {tariffStep === 'compare' ? `Переход на план ${selectedTariff === 'pro' ? 'PRO' : 'TOP'}` : 'Успешно'}
              </h3>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-12889" />} onClick={() => setShowTariffModal(false)} data-id="element-12888" />
            </div>

            <div className="p-6 overflow-y-auto bg-slate-50 flex-1" data-id="element-12890">
              {tariffStep === 'compare' && <div className="space-y-6" data-id="element-12891">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-12892">
                    {/* Current Plan */}
                    <Card padding="md" className="border-slate-200 bg-white opacity-60" data-id="element-12893">
                      <div className="text-sm font-bold text-slate-500 mb-1" data-id="element-12894">
                        Текущий план
                      </div>
                      <div className="text-xl font-bold text-slate-900 mb-4" data-id="element-12895">
                        Базовый
                      </div>
                      <ul className="space-y-3" data-id="element-12896">
                        <li className="flex items-start gap-2 text-sm text-slate-500" data-id="element-12897">
                          <Check className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" data-id="element-12898" />{' '}
                          Базовый профиль
                        </li>
                        <li className="flex items-start gap-2 text-sm text-slate-500" data-id="element-12899">
                          <Check className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" data-id="element-12900" />{' '}
                          До 3 услуг
                        </li>
                        <li className="flex items-start gap-2 text-sm text-slate-500" data-id="element-12901">
                          <Check className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" data-id="element-12902" />{' '}
                          Стандартная позиция
                        </li>
                      </ul>
                    </Card>

                    {/* New Plan */}
                    <Card padding="md" className={`border-2 ${selectedTariff === 'pro' ? 'border-indigo-400 bg-indigo-50/30' : 'border-amber-400 bg-amber-50/30'}`} data-id="element-12903">
                      <div className={`text-sm font-bold mb-1 ${selectedTariff === 'pro' ? 'text-indigo-600' : 'text-amber-600'}`} data-id="element-12904">
                        Новый план
                      </div>
                      <div className="flex items-center gap-2 mb-4" data-id="element-12905">
                        <div className="text-xl font-bold text-slate-900" data-id="element-12906">
                          {selectedTariff === 'pro' ? 'PRO' : 'TOP'}
                        </div>
                        {selectedTariff === 'pro' ? <ShieldCheck className="w-5 h-5 text-indigo-500" data-id="element-12907" /> : <Crown className="w-5 h-5 text-amber-500" data-id="element-12908" />}
                      </div>

                      <ul className="space-y-3" data-id="element-12909">
                        {selectedTariff === 'pro' ? <>
                            <li className="flex items-start gap-2 text-sm text-slate-800 font-medium" data-id="element-12910">
                              <Check className="w-4 h-4 text-indigo-500 mt-0.5 shrink-0" data-id="element-12911" />{' '}
                              Бейдж PRO (верификация)
                            </li>
                            <li className="flex items-start gap-2 text-sm text-slate-800" data-id="element-12912">
                              <Check className="w-4 h-4 text-indigo-500 mt-0.5 shrink-0" data-id="element-12913" />{' '}
                              Приоритет в поиске
                            </li>
                            <li className="flex items-start gap-2 text-sm text-slate-800" data-id="element-12914">
                              <Check className="w-4 h-4 text-indigo-500 mt-0.5 shrink-0" data-id="element-12915" />{' '}
                              До 10 услуг
                            </li>
                            <li className="flex items-start gap-2 text-sm text-slate-800" data-id="element-12916">
                              <Check className="w-4 h-4 text-indigo-500 mt-0.5 shrink-0" data-id="element-12917" />{' '}
                              Расширенная аналитика
                            </li>
                          </> : <>
                            <li className="flex items-start gap-2 text-sm text-slate-800 font-medium" data-id="element-12918">
                              <Check className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" data-id="element-12919" />{' '}
                              Бейдж TOP Астролог
                            </li>
                            <li className="flex items-start gap-2 text-sm text-amber-700 font-bold bg-amber-100/50 p-1.5 rounded" data-id="element-12920">
                              <Target className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" data-id="element-12921" />{' '}
                              Закрепление вверху каталога — включено!
                            </li>
                            <li className="flex items-start gap-2 text-sm text-slate-800" data-id="element-12922">
                              <Check className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" data-id="element-12923" />{' '}
                              Блок на главной странице
                            </li>
                            <li className="flex items-start gap-2 text-sm text-slate-800" data-id="element-12924">
                              <Check className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" data-id="element-12925" />{' '}
                              Неограниченно услуг
                            </li>
                          </>}
                      </ul>
                    </Card>
                  </div>

                  <div className="flex justify-between items-center bg-white p-4 rounded-xl border border-slate-200" data-id="element-12926">
                    <span className="text-sm text-slate-600" data-id="element-12927">
                      Стоимость подписки
                    </span>
                    <span className="text-xl font-bold text-slate-900" data-id="element-12928">
                      {selectedTariff === 'pro' ? '3 000 ₽/мес' : '7 000 ₽/мес'}
                    </span>
                  </div>
                </div>}

              {tariffStep === 'success' && <div className="flex flex-col items-center justify-center py-8 text-center" data-id="element-12929">
                  <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4" data-id="element-12930">
                    <CheckCircle2 className="w-8 h-8 text-emerald-600" data-id="element-12931" />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-12932">
                    План {selectedTariff === 'pro' ? 'PRO' : 'TOP'} активирован!
                  </h3>
                  <p className="text-slate-600 max-w-sm mb-6" data-id="element-12933">
                    {selectedTariff === 'top' ? 'Ваш профиль автоматически закреплён в каталоге. Все новые функции уже доступны.' : 'Все функции плана PRO успешно активированы и доступны для использования.'}
                  </p>
                </div>}
            </div>

            <div className="p-4 border-t border-slate-200 bg-white flex justify-end gap-3 shrink-0" data-id="element-12934">
              {tariffStep === 'compare' && <>
                  <Button variant="outline" onClick={() => setShowTariffModal(false)} data-id="element-12935">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => setTariffStep('success')} data-id="element-12936">
                    Подтвердить переход
                  </Button>
                </>}
              {tariffStep === 'success' && <Button variant="primary" onClick={() => setShowTariffModal(false)} data-id="element-12937">
                  Готово
                </Button>}
            </div>
          </Card>
        </div>}

      {/* Banner Modal */}
      {showBannerModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm" data-id="element-12938">
          <Card className="w-full max-w-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]" padding="none" data-id="element-12939">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-white shrink-0" data-id="element-12940">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-12941">
                {bannerStep === 1 && 'Выберите слот для баннера'}
                {bannerStep === 2 && 'Выберите срок размещения'}
                {bannerStep === 3 && 'Подтверждение заказа'}
                {bannerStep === 'success' && 'Успешно'}
              </h3>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-12943" />} onClick={() => setShowBannerModal(false)} data-id="element-12942" />
            </div>

            <div className="p-6 overflow-y-auto bg-slate-50 flex-1" data-id="element-12944">
              {bannerStep === 1 && <div className="space-y-4" data-id="element-12945">
                  <p className="text-sm text-slate-600 mb-4" data-id="element-12946">
                    Выберите слот для размещения баннера на главной странице.
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-12947">
                    {['Главная TOP', 'Главная Бокс', 'Каталог Слева', 'Каталог Справа', 'Фильтр Слева', 'Фильтр Справа'].map(slot => <label key={slot} className={`flex items-center gap-3 p-3 rounded-xl border cursor-pointer transition-colors ${selectedBannerSlot === slot ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-12948">
                        <input type="radio" name="slot" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedBannerSlot === slot} onChange={() => setSelectedBannerSlot(slot)} data-id="element-12949" />
                        <span className="text-sm font-medium text-slate-700" data-id="element-12950">
                          {slot}
                        </span>
                      </label>)}
                  </div>
                </div>}

              {bannerStep === 2 && <div className="space-y-4" data-id="element-12951">
                  <div className="grid grid-cols-1 gap-3" data-id="element-12952">
                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedBannerDuration === '1week' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-12953">
                      <div className="flex items-center gap-3" data-id="element-12954">
                        <input type="radio" name="duration" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedBannerDuration === '1week'} onChange={() => setSelectedBannerDuration('1week')} data-id="element-12955" />
                        <span className="font-bold text-slate-900" data-id="element-12956">
                          1 неделя
                        </span>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-12957">
                        5 000 ₽ / раз
                      </div>
                    </label>

                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedBannerDuration === '2weeks' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-12958">
                      <div className="flex items-center gap-3" data-id="element-12959">
                        <input type="radio" name="duration" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedBannerDuration === '2weeks'} onChange={() => setSelectedBannerDuration('2weeks')} data-id="element-12960" />
                        <div className="flex items-center gap-2" data-id="element-12961">
                          <span className="font-bold text-slate-900" data-id="element-12962">
                            2 недели
                          </span>
                          <Badge variant="success" size="sm" className="text-[10px]" data-id="element-12963">
                            -12%
                          </Badge>
                        </div>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-12964">
                        9 000 ₽ / раз
                      </div>
                    </label>

                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedBannerDuration === '1month' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-12965">
                      <div className="flex items-center gap-3" data-id="element-12966">
                        <input type="radio" name="duration" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedBannerDuration === '1month'} onChange={() => setSelectedBannerDuration('1month')} data-id="element-12967" />
                        <div className="flex items-center gap-2" data-id="element-12968">
                          <span className="font-bold text-slate-900" data-id="element-12969">
                            1 месяц
                          </span>
                          <Badge variant="success" size="sm" className="text-[10px]" data-id="element-12970">
                            -25%
                          </Badge>
                        </div>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-12971">
                        18 000 ₽ / раз
                      </div>
                    </label>
                  </div>

                  <div className="bg-white p-4 rounded-xl border border-slate-200 mt-4 flex justify-between items-center" data-id="element-12972">
                    <span className="text-sm text-slate-600" data-id="element-12973">
                      {selectedBannerDuration === '1week' ? '5 000' : selectedBannerDuration === '2weeks' ? '9 000' : '18 000'}{' '}
                      ₽ / раз
                    </span>
                    <span className="text-lg font-bold text-slate-900" data-id="element-12974">
                      {selectedBannerDuration === '1week' ? 5000 : selectedBannerDuration === '2weeks' ? 9000 : 18000}{' '}
                      ₽
                    </span>
                  </div>
                </div>}

              {bannerStep === 3 && <div className="space-y-6" data-id="element-12975">
                  <Card padding="md" className="border-slate-200 bg-white" data-id="element-12976">
                    <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-12977">
                      Детали заказа
                    </h4>

                    <div className="space-y-3 text-sm" data-id="element-12978">
                      <div className="flex justify-between pb-3 border-b border-slate-100" data-id="element-12979">
                        <span className="text-slate-500" data-id="element-12980">Слот размещения</span>
                        <span className="font-medium text-slate-900" data-id="element-12981">
                          {selectedBannerSlot}
                        </span>
                      </div>
                      <div className="flex justify-between pb-3 border-b border-slate-100" data-id="element-12982">
                        <span className="text-slate-500" data-id="element-12983">Срок размещения</span>
                        <span className="font-medium text-slate-900" data-id="element-12984">
                          {selectedBannerDuration === '1week' ? '1 неделя' : selectedBannerDuration === '2weeks' ? '2 недели' : '1 месяц'}
                        </span>
                      </div>
                      <div className="flex justify-between items-center pt-2" data-id="element-12985">
                        <span className="text-base font-bold text-slate-900" data-id="element-12986">
                          Итого к оплате
                        </span>
                        <span className="text-xl font-bold text-indigo-600" data-id="element-12987">
                          {selectedBannerDuration === '1week' ? 5000 : selectedBannerDuration === '2weeks' ? 9000 : 18000}{' '}
                          ₽
                        </span>
                      </div>
                    </div>
                  </Card>

                  <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex gap-3" data-id="element-12988">
                    <Target className="w-5 h-5 text-amber-600 shrink-0" data-id="element-12989" />
                    <div className="text-sm text-amber-800" data-id="element-12990">
                      После оплаты баннер будет размещён в выбранном слоте на
                      главной странице.
                    </div>
                  </div>
                </div>}

              {bannerStep === 'success' && <div className="flex flex-col items-center justify-center py-8 text-center" data-id="element-12991">
                  <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4" data-id="element-12992">
                    <CheckCircle2 className="w-8 h-8 text-emerald-600" data-id="element-12993" />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-12994">
                    Баннер оформлен!
                  </h3>
                  <p className="text-slate-600 max-w-sm mb-6" data-id="element-12995">
                    Баннер будет размещён в выбранном слоте на главной странице
                    платформы. Вы можете управлять баннерами на вкладке
                    "Продвижение".
                  </p>
                </div>}
            </div>

            <div className="p-4 border-t border-slate-200 bg-white flex justify-between shrink-0" data-id="element-12996">
              {bannerStep === 1 && <>
                  <Button variant="outline" onClick={() => setShowBannerModal(false)} data-id="element-12997">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => setBannerStep(2)} data-id="element-12998">
                    Далее <ArrowRight className="w-4 h-4 ml-1" data-id="element-12999" />
                  </Button>
                </>}
              {bannerStep === 2 && <>
                  <Button variant="outline" onClick={() => setBannerStep(1)} data-id="element-13000">
                    Назад
                  </Button>
                  <Button variant="primary" onClick={() => setBannerStep(3)} data-id="element-13001">
                    Далее <ArrowRight className="w-4 h-4 ml-1" data-id="element-13002" />
                  </Button>
                </>}
              {bannerStep === 3 && <>
                  <Button variant="outline" onClick={() => setBannerStep(2)} data-id="element-13003">
                    Назад
                  </Button>
                  <Button variant="primary" onClick={() => {
              // Add to my orders
              const newOrder = {
                id: `ORD-A-${Date.now()}`,
                type: 'banner',
                name: 'Баннер на главной',
                status: 'active',
                startDate: new Date().toISOString().split('T')[0],
                endDate: selectedBannerDuration === '1week' ? new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0] : selectedBannerDuration === '2weeks' ? new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0] : new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                price: selectedBannerDuration === '1week' ? 5000 : selectedBannerDuration === '2weeks' ? 9000 : 18000,
                views: 0
              };
              setMyOrders(prev => [...prev, newOrder]);
              setBannerStep('success');
            }} data-id="element-13004">
                    Оплатить{' '}
                    {selectedBannerDuration === '1week' ? 5000 : selectedBannerDuration === '2weeks' ? 9000 : 18000}{' '}
                    ₽
                  </Button>
                </>}
              {bannerStep === 'success' && <Button variant="primary" fullWidth onClick={() => setShowBannerModal(false)} data-id="element-13005">
                  Готово
                </Button>}
            </div>
          </Card>
        </div>}

      {/* Email Modal */}
      {showEmailModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm" data-id="element-13006">
          <Card className="w-full max-w-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]" padding="none" data-id="element-13007">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-white shrink-0" data-id="element-13008">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-13009">
                {emailStep === 1 && 'Выберите размер аудитории'}
                {emailStep === 2 && 'Подготовьте материалы'}
                {emailStep === 3 && 'Подтверждение заказа'}
                {emailStep === 'success' && 'Успешно'}
              </h3>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-13011" />} onClick={() => setShowEmailModal(false)} data-id="element-13010" />
            </div>

            <div className="p-6 overflow-y-auto bg-slate-50 flex-1" data-id="element-13012">
              {emailStep === 1 && <div className="space-y-4" data-id="element-13013">
                  <p className="text-sm text-slate-600 mb-4" data-id="element-13014">
                    Выберите размер аудитории для email-рассылки по базе
                    пользователей AstroGuide.
                  </p>
                  <div className="grid grid-cols-1 gap-3" data-id="element-13015">
                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedEmailAudience === '5k' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-13016">
                      <div className="flex items-center gap-3" data-id="element-13017">
                        <input type="radio" name="audience" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedEmailAudience === '5k'} onChange={() => setSelectedEmailAudience('5k')} data-id="element-13018" />
                        <span className="font-bold text-slate-900" data-id="element-13019">
                          5 000 пользователей
                        </span>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-13020">
                        1 500 ₽
                      </div>
                    </label>

                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedEmailAudience === '10k' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-13021">
                      <div className="flex items-center gap-3" data-id="element-13022">
                        <input type="radio" name="audience" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedEmailAudience === '10k'} onChange={() => setSelectedEmailAudience('10k')} data-id="element-13023" />
                        <div className="flex items-center gap-2" data-id="element-13024">
                          <span className="font-bold text-slate-900" data-id="element-13025">
                            10 000 пользователей
                          </span>
                          <Badge variant="pro" size="sm" className="text-[10px]" data-id="element-13026">
                            Популярно
                          </Badge>
                        </div>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-13027">
                        3 000 ₽
                      </div>
                    </label>

                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedEmailAudience === '25k' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-13028">
                      <div className="flex items-center gap-3" data-id="element-13029">
                        <input type="radio" name="audience" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedEmailAudience === '25k'} onChange={() => setSelectedEmailAudience('25k')} data-id="element-13030" />
                        <span className="font-bold text-slate-900" data-id="element-13031">
                          25 000 пользователей
                        </span>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-13032">
                        5 000 ₽
                      </div>
                    </label>

                    <label className={`flex items-center justify-between p-4 rounded-xl border cursor-pointer transition-colors ${selectedEmailAudience === 'all' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-white hover:border-indigo-200'}`} data-id="element-13033">
                      <div className="flex items-center gap-3" data-id="element-13034">
                        <input type="radio" name="audience" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedEmailAudience === 'all'} onChange={() => setSelectedEmailAudience('all')} data-id="element-13035" />
                        <div className="flex items-center gap-2" data-id="element-13036">
                          <span className="font-bold text-slate-900" data-id="element-13037">
                            Вся активная база (~45 000)
                          </span>
                          <Badge variant="success" size="sm" className="text-[10px]" data-id="element-13038">
                            Выгодно
                          </Badge>
                        </div>
                      </div>
                      <div className="text-sm font-bold text-slate-700" data-id="element-13039">
                        8 000 ₽
                      </div>
                    </label>
                  </div>
                </div>}

              {emailStep === 2 && <div className="space-y-4" data-id="element-13040">
                  <p className="text-sm text-slate-600 mb-4" data-id="element-13041">
                    Опишите, что вы хотите рассказать аудитории. Наш редактор
                    подготовит красивое письмо на основе ваших материалов.
                  </p>
                  <div data-id="element-13042">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-13043">
                      Тема письма (пожелание)
                    </label>
                    <input type="text" placeholder="Например: Скидка 20% на консультацию до конца месяца" className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-13044" />
                  </div>
                  <div data-id="element-13045">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-13046">
                      Текст для рассылки
                    </label>
                    <textarea rows={5} placeholder="Опишите ваше предложение, услуги или акцию..." className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-13047" />
                  </div>
                  <div data-id="element-13048">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-13049">
                      Материалы (фото, баннеры)
                    </label>
                    <div className="border-2 border-dashed border-slate-300 rounded-xl p-6 text-center hover:bg-slate-50 transition-colors cursor-pointer" data-id="element-13050">
                      <div className="text-sm text-slate-500" data-id="element-13051">
                        Нажмите или перетащите файлы сюда
                      </div>
                      <div className="text-xs text-slate-400 mt-1" data-id="element-13052">
                        JPG, PNG до 5 МБ
                      </div>
                    </div>
                  </div>
                </div>}

              {emailStep === 3 && <div className="space-y-6" data-id="element-13053">
                  <Card padding="md" className="border-slate-200 bg-white" data-id="element-13054">
                    <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-13055">
                      Детали заказа
                    </h4>

                    <div className="space-y-3 text-sm" data-id="element-13056">
                      <div className="flex justify-between pb-3 border-b border-slate-100" data-id="element-13057">
                        <span className="text-slate-500" data-id="element-13058">Услуга</span>
                        <span className="font-medium text-slate-900" data-id="element-13059">
                          Email-рассылка по базе
                        </span>
                      </div>
                      <div className="flex justify-between pb-3 border-b border-slate-100" data-id="element-13060">
                        <span className="text-slate-500" data-id="element-13061">Аудитория</span>
                        <span className="font-medium text-slate-900" data-id="element-13062">
                          {selectedEmailAudience === '5k' ? '5 000 пользователей' : selectedEmailAudience === '10k' ? '10 000 пользователей' : selectedEmailAudience === '25k' ? '25 000 пользователей' : 'Вся активная база (~45 000)'}
                        </span>
                      </div>
                      <div className="flex justify-between items-center pt-2" data-id="element-13063">
                        <span className="text-base font-bold text-slate-900" data-id="element-13064">
                          Итого к оплате
                        </span>
                        <span className="text-xl font-bold text-indigo-600" data-id="element-13065">
                          {selectedEmailAudience === '5k' ? '1 500' : selectedEmailAudience === '10k' ? '3 000' : selectedEmailAudience === '25k' ? '5 000' : '8 000'}{' '}
                          ₽
                        </span>
                      </div>
                    </div>
                  </Card>

                  <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 flex gap-3" data-id="element-13066">
                    <Megaphone className="w-5 h-5 text-emerald-600 shrink-0" data-id="element-13067" />
                    <div className="text-sm text-emerald-800" data-id="element-13068">
                      После оплаты наш модератор свяжется с вами для
                      согласования итогового макета письма перед отправкой.
                    </div>
                  </div>
                </div>}

              {emailStep === 'success' && <div className="flex flex-col items-center justify-center py-8 text-center" data-id="element-13069">
                  <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4" data-id="element-13070">
                    <CheckCircle2 className="w-8 h-8 text-emerald-600" data-id="element-13071" />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-13072">
                    Заказ оформлен!
                  </h3>
                  <p className="text-slate-600 max-w-sm mb-6" data-id="element-13073">
                    Ваша заявка на рассылку принята. Модератор свяжется с вами в
                    течение 24 часов для согласования материалов.
                  </p>
                </div>}
            </div>

            <div className="p-4 border-t border-slate-200 bg-white flex justify-between shrink-0" data-id="element-13074">
              {emailStep === 1 && <>
                  <Button variant="outline" onClick={() => setShowEmailModal(false)} data-id="element-13075">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => setEmailStep(2)} data-id="element-13076">
                    Далее <ArrowRight className="w-4 h-4 ml-1" data-id="element-13077" />
                  </Button>
                </>}
              {emailStep === 2 && <>
                  <Button variant="outline" onClick={() => setEmailStep(1)} data-id="element-13078">
                    Назад
                  </Button>
                  <Button variant="primary" onClick={() => setEmailStep(3)} data-id="element-13079">
                    Далее <ArrowRight className="w-4 h-4 ml-1" data-id="element-13080" />
                  </Button>
                </>}
              {emailStep === 3 && <>
                  <Button variant="outline" onClick={() => setEmailStep(2)} data-id="element-13081">
                    Назад
                  </Button>
                  <Button variant="primary" onClick={() => {
              const price = selectedEmailAudience === '5k' ? 1500 : selectedEmailAudience === '10k' ? 3000 : selectedEmailAudience === '25k' ? 5000 : 8000;
              const newOrder = {
                id: `ORD-A-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
                type: 'email',
                name: 'Рассылка по базе',
                status: 'pending',
                startDate: new Date().toLocaleDateString('ru-RU'),
                endDate: null,
                price: price,
                views: 0
              };
              setMyOrders(prev => [newOrder, ...prev]);
              setEmailStep('success');
            }} data-id="element-13082">
                    Оплатить{' '}
                    {selectedEmailAudience === '5k' ? '1 500' : selectedEmailAudience === '10k' ? '3 000' : selectedEmailAudience === '25k' ? '5 000' : '8 000'}{' '}
                    ₽
                  </Button>
                </>}
              {emailStep === 'success' && <Button variant="primary" fullWidth onClick={() => setShowEmailModal(false)} data-id="element-13083">
                  Готово
                </Button>}
            </div>
          </Card>
        </div>}

      {/* Package Purchase Modal */}
      {showPackageModal && selectedPackage && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm" data-id="element-13084">
          <Card className="w-full max-w-md shadow-2xl overflow-hidden flex flex-col" padding="none" data-id="element-13085">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-white" data-id="element-13086">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-13087">
                Покупка пакета услуг
              </h3>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-13089" />} onClick={() => setShowPackageModal(false)} data-id="element-13088" />
            </div>
            <div className="p-6 bg-slate-50" data-id="element-13090">
              <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 text-indigo-600 rounded-full mx-auto mb-4" data-id="element-13091">
                <ShoppingBag className="w-8 h-8" data-id="element-13092" />
              </div>
              <h4 className="text-xl font-bold text-center text-slate-900 mb-2" data-id="element-13093">
                {selectedPackage.name}
              </h4>
              <p className="text-center text-slate-500 mb-6" data-id="element-13094">
                Пакет на {selectedPackage.qty} шт.
              </p>

              <div className="bg-white rounded-xl border border-slate-200 p-4 mb-6" data-id="element-13095">
                <div className="flex justify-between items-center mb-2" data-id="element-13096">
                  <span className="text-slate-600" data-id="element-13097">Количество</span>
                  <span className="font-bold text-slate-900" data-id="element-13098">
                    {selectedPackage.qty} шт.
                  </span>
                </div>
                {selectedPackage.discount && <div className="flex justify-between items-center mb-2" data-id="element-13099">
                    <span className="text-slate-600" data-id="element-13100">Скидка за объем</span>
                    <Badge variant="success" size="sm" data-id="element-13101">
                      {selectedPackage.discount}
                    </Badge>
                  </div>}
                <div className="flex justify-between items-center pt-2 border-t border-slate-100 mt-2" data-id="element-13102">
                  <span className="font-bold text-slate-900" data-id="element-13103">
                    Итого к оплате
                  </span>
                  <span className="text-xl font-bold text-indigo-600" data-id="element-13104">
                    {selectedPackage.price.toLocaleString('ru-RU')} ₽
                  </span>
                </div>
              </div>

              <div className="flex gap-3" data-id="element-13105">
                <Button variant="outline" fullWidth onClick={() => setShowPackageModal(false)} data-id="element-13106">
                  Отмена
                </Button>
                <Button variant="primary" fullWidth onClick={() => {
              const newOrder = {
                id: `ORD-A-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
                type: 'package',
                name: `Пакет ${selectedPackage.name} ×${selectedPackage.qty}`,
                status: 'active',
                startDate: new Date().toLocaleDateString('ru-RU'),
                endDate: null,
                price: selectedPackage.price,
                remaining: selectedPackage.qty
              };
              setMyOrders(prev => [newOrder, ...prev]);
              setShowPackageModal(false);
              showToast(`Пакет ${selectedPackage.name} успешно куплен!`);
            }} data-id="element-13107">
                  Оплатить
                </Button>
              </div>
            </div>
          </Card>
        </div>}

      {/* My Orders */}
      <div className="mt-10 mb-8" data-id="element-13108">
        <h3 className="text-lg font-bold text-slate-900 mb-4" data-id="element-13109">Мои заказы</h3>
        <div className="space-y-4" data-id="element-13110">
          {myOrders.map(order => <Card key={order.id} padding="md" className={`border-l-4 ${order.status === 'active' ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-200 bg-slate-50'}`} data-id="element-13111">
              <div className="flex items-center justify-between mb-3" data-id="element-13112">
                <div className="flex items-center gap-3" data-id="element-13113">
                  <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center" data-id="element-13114">
                    <Target className="w-5 h-5 text-slate-600" data-id="element-13115" />
                  </div>
                  <div data-id="element-13116">
                    <h4 className="font-bold text-slate-900" data-id="element-13117">{order.name}</h4>
                    <div className="text-xs text-slate-500" data-id="element-13118">
                      {order.status === 'active' ? 'Активен' : 'Завершён'}
                    </div>
                  </div>
                </div>
                <div className="text-right" data-id="element-13119">
                  <div className="text-lg font-bold text-slate-900" data-id="element-13120">
                    {order.price} ₽
                  </div>
                  {order.status === 'active' && order.endDate && <div className="text-xs text-slate-500" data-id="element-13121">
                      До {order.endDate}
                    </div>}
                </div>
              </div>

              <div className="flex items-center justify-between" data-id="element-13122">
                <div className="flex items-center gap-2" data-id="element-13123">
                  <div className="text-xs text-slate-500" data-id="element-13124">
                    {order.status === 'active' ? 'Осталось' : 'Просмотры'}
                  </div>
                  <div className="text-sm font-medium text-slate-900" data-id="element-13125">
                    {order.status === 'active' ? order.remaining : order.views}{' '}
                    {order.status === 'active' ? 'шт' : 'просмотров'}
                  </div>
                </div>
                <div className="text-xs text-slate-500" data-id="element-13126">
                  {order.status === 'active' ? 'Ожидание' : 'Просмотры'}
                </div>
              </div>
            </Card>)}
        </div>
      </div>

      {/* Section 5: Пакеты для продвижения */}
      <h3 className="text-lg font-bold text-slate-900 mt-10 mb-4" data-id="element-13127">
        Пакеты для продвижения
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-13128">
        <Card padding="md" className="flex flex-col h-full hover:border-indigo-300 transition-colors" data-id="element-13129">
          <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center mb-4" data-id="element-13130">
            <LayoutGrid className="w-6 h-6 text-indigo-600" data-id="element-13131" />
          </div>
          <h4 className="font-bold text-slate-900 mb-1" data-id="element-13132">
            Пакет Натальная карта ×100
          </h4>
          <div className="text-indigo-600 font-bold mb-3" data-id="element-13133">
            6 900 ₽{' '}
            <span className="text-xs text-slate-500 font-normal" data-id="element-13134">/ пакет</span>
          </div>
          <p className="text-sm text-slate-600 mb-6 flex-1" data-id="element-13135">
            Полный пакет 100 натальных карт. Включает все аспекты, дома,
            планеты, рекомендации.
          </p>
          <Button variant="outline" fullWidth onClick={() => {
          setShowPackageModal(true);
          setSelectedPackage({
            name: 'Натальная карта ×100',
            qty: 100,
            price: 6900,
            discount: 30
          });
        }} data-id="element-13136">
            Заказать
          </Button>
        </Card>

        <Card padding="md" className="flex flex-col h-full hover:border-indigo-300 transition-colors" data-id="element-13137">
          <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mb-4" data-id="element-13138">
            <Target className="w-6 h-6 text-rose-600" data-id="element-13139" />
          </div>
          <h4 className="font-bold text-slate-900 mb-1" data-id="element-13140">Пакет Соляр ×100</h4>
          <div className="text-rose-600 font-bold mb-3" data-id="element-13141">
            10 400 ₽{' '}
            <span className="text-xs text-slate-500 font-normal" data-id="element-13142">/ пакет</span>
          </div>
          <p className="text-sm text-slate-600 mb-6 flex-1" data-id="element-13143">
            Полный пакет 100 солярных карт. Включает полный прогноз на год с
            рекомендациями.
          </p>
          <Button variant="outline" fullWidth onClick={() => {
          setShowPackageModal(true);
          setSelectedPackage({
            name: 'Соляр ×100',
            qty: 100,
            price: 10400,
            discount: 30
          });
        }} data-id="element-13144">
            Заказать
          </Button>
        </Card>

        <Card padding="md" className="flex flex-col h-full hover:border-indigo-300 transition-colors" data-id="element-13145">
          <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center mb-4" data-id="element-13146">
            <Megaphone className="w-6 h-6 text-emerald-600" data-id="element-13147" />
          </div>
          <h4 className="font-bold text-slate-900 mb-1" data-id="element-13148">
            Пакет Синастрия ×100
          </h4>
          <div className="text-emerald-600 font-bold mb-3" data-id="element-13149">
            9 000 ₽{' '}
            <span className="text-xs text-slate-500 font-normal" data-id="element-13150">/ пакет</span>
          </div>
          <p className="text-sm text-slate-600 mb-6 flex-1" data-id="element-13151">
            Полный пакет 100 синастрий. Включает подробный анализ совместимости
            пар.
          </p>
          <Button variant="outline" fullWidth onClick={() => {
          setShowPackageModal(true);
          setSelectedPackage({
            name: 'Синастрия ×100',
            qty: 100,
            price: 9000,
            discount: 30
          });
        }} data-id="element-13152">
            Заказать
          </Button>
        </Card>
      </div>
    </div>;
}